import {
    getLoadingStatuses,
    getAssetsLoadingStatus,
    getPowertrainLoadingStatusv2,
    getContextLoadingStatus
} from 'helpers/selectors';
import { createSelector } from 'reselect';
import { getFormattedPowertrains } from '../selectors';

const getSelectedPowertrain = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedPowertrain;
};

const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

const getNewCapability = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.newAssetCapability;
};


export const getModel = createSelector(
    [
        getLoadingStatuses,
        getPowertrainLoadingStatusv2,
        getAssetsLoadingStatus,
        getContextLoadingStatus,
        getFormattedPowertrains,
        getSelectedPowertrain,
        getSelectedAsset,
        getNewCapability
    ],
    (
        generalFilterLoadingStatus,
        powertrainsLoadingStatus,
        assetsLoadingStatus,
        contextLoadingStatus,
        formattedPowertrains,
        selectedPowertrain,
        selectedAsset,
        newSelectedAssetCapability
    ) => {
        return {
            generalFilterLoadingStatus,
            powertrainsLoadingStatus,
            assetsLoadingStatus,
            contextLoadingStatus,
            formattedPowertrains,
            selectedPowertrain,
            selectedAsset,
            newSelectedAssetCapability
        };
    }
);
